import { ISODateTime } from '@interticket/core';
import { IDefaultChannelSettings } from '../../interfaces/event/event-default-channel-settings.interface';

export class DefaultChannelSettings implements IDefaultChannelSettings {

  readonly visibleFrom: ISODateTime;
  readonly visibleTo: ISODateTime;
  readonly availableFrom: ISODateTime;
  readonly availableTo: ISODateTime;

  constructor(iDefaultChannelSettings: IDefaultChannelSettings) {
    this.visibleFrom = iDefaultChannelSettings.visibleFrom;
    this.visibleTo = iDefaultChannelSettings.visibleTo;
    this.availableFrom = iDefaultChannelSettings.availableFrom;
    this.availableTo = iDefaultChannelSettings.availableTo;
  }

}
